// The escorts directory (app/escorts) lives at its own address, like the game (config/game.ts), so a country that
// blocks it blocks that name and not the site. Its listings come from AdultWork.com's API (lib/escorts).
export const ESCORTS_HOST = "escorts.sweet.xxx";
export const ESCORTS_URL = `https://${ESCORTS_HOST}/`;

/** A directory page's full address, for canonical links, sitemaps and links from the site. */
export const escortsUrl = (path = "") => `${ESCORTS_URL}${path.replace(/^\//, "")}`;

/**
 * Where the directory's pages are on the server the page is served from: the root of its own address in
 * production (src/proxy.ts sends /escorts on the site there), /escorts in development (localhost).
 */
export const ESCORTS_BASE = process.env.NODE_ENV === "production" ? "" : "/escorts";

/** A directory page's path, for links between its pages. */
export const escortsPath = (path = "") => `${ESCORTS_BASE}/${path.replace(/^\//, "")}`.replace(/\/$/, "") || "/";

/**
 * Countries whose visitors may see the directory, until Admin → Escorts changes them (lib/escorts/settings.ts):
 * where selling sex and advertising it are lawful for a site like ours (materials/reports/Источники анкет эскорта и
 * законы.md). The UK's listings leave out Northern Ireland and the Channel Islands (lib/escorts/places.ts);
 * Belgium and Australia (rules by state) stay out until checked. Lower case.
 */
export const ESCORTS_COUNTRIES = ["gb", "de", "nl", "ch", "at", "it", "cz", "nz", "br", "co", "cl", "pe", "do"] as const;
